import { FC } from "react";
import { Icon, IconProps } from "./components/Icon";

const Plus: FC<IconProps> = ({ ...props }) => {
  return <Icon {...props} d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />;
};

export { Plus };
